import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { makeStyles, Tooltip } from '@material-ui/core';
import PartnerBankIcon from 'app/assets/icon/partnerBankIcon';
import { contaApi } from 'app/services/api/contaApi';
import React from 'react';

const useStyles = makeStyles({
  containerPrincipal: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'inline-block',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  badge: {
    backgroundColor: '#54c6e8',
    color: '#ffffff',
    margin: 8,
    marginRight: 12,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 10,
    fontWeight: 600,
  },
  partnerBank: {
    marginLeft: 10,
  },
  encerradas: {
    marginLeft: 5,
  }
});

const SelectConta = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  warning,
  onBlur,
  onChange,
  disabled = false,
  required,
  fullWidth,
  // RNE-092
  tiposConta = ['CONTA_CORRENTE', 'CONTA_POUPANCA', 'CONTA_CAIXINHA', 'CONTA_CARTAO', 'CONTA_INVESTIMENTO'],
  // Se verdadeiro, irá buscar apenas as contas que pertencem a bancos homologados.
  homologadas = false,
  incluirEncerradas = false,
}) => {
  const styles = useStyles();

  const formatOption = (option) => {
    let sufixo = '';
    if (option?.contaBancaria) {
      const {
        contaBancaria: { agencia, agenciaDigito, numeroConta, contaDigito },
      } = option;

      const agenciaDigitoString = agenciaDigito ? `-${agenciaDigito}` : '';

      if (option?.contaBancaria?.dataEncerramento) {
        sufixo = `${agencia}${agenciaDigitoString}/${numeroConta}-${contaDigito}  - ENC`;
      } else {
         sufixo = `${agencia}${agenciaDigitoString}/${numeroConta}-${contaDigito}`;
      }
      
    } else if (option?.contaCaixinha?.dataEncerramento) {
        sufixo = ` - ENC`
    }

    return option?.descricao ? `${option?.descricao} ${sufixo}` : '';
  };

  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      fullWidth={fullWidth}
      disabled={disabled}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      required={required}
      touched={touched}
      error={error}
      warning={warning}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => formatOption(option)}
      renderOption={(option) => {
        const labelOption = formatOption(option);

        if (option?.partnerBank) {
          return (
            <Tooltip title={labelOption}>
              <div className={styles.containerPrincipal} style={{ maxWidth: '100%' }}>
                <div className={styles.container}>{labelOption}</div>
                <div className={styles.partnerBank}>
                  <PartnerBankIcon size="20" />
                </div>
              </div>
            </Tooltip>
          );
        }
        if (option?.contaBancaria?.principal) {
          return (
            <Tooltip title={labelOption}>
              <div className={styles.containerPrincipal} style={{ maxWidth: '100%' }}>
                <div className={styles.container}>{labelOption}</div>
                <div className={styles.badge}>Principal</div>
              </div>
            </Tooltip>
          );
        }
        return (
          <Tooltip title={labelOption}>
            <div className={styles.container} style={{ maxWidth: '100%' }}>
              {labelOption}
            </div>
          </Tooltip>
        );
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await contaApi.pesquisar({
          size: 100,
          sort: 'descricao',
          page: next,
          q: query,
          tiposConta,
          homologadas,
          incluirEncerradas,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
    />
  );

  // return (
  //   <>
  //     <div>
  //       <div className={styles.badge}>Principal</div>Conta bancária 12678-1 45787-8
  //     </div>
  //   </>
  // );
};

export default SelectConta;
